import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, createCourier, mapCourierError, useTranslation } from '@dukanti/shared';
import type { Courier, CourierInput, TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useCreateCourier(
  storeId: string,
): UseMutationResult<Courier, unknown, CourierInput> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<Courier, unknown, CourierInput>({
    mutationFn: (input) => createCourier(supabase, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.list(storeId) });
      toast.success(t('admin.couriers.toasts.created' as TranslationKey));
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
